import { Environment } from '@enauka/shared/application';

class EnvironmentImpl extends Environment {
  version = 'enauka-zeszyt-online-{BUILD_VERSION}';
  production = true;
  logowanieUsos = true;
}
export const environment = new EnvironmentImpl();
